<template>
  <div class="addr-update">
    <!-- 修改商城订单收货地址弹出框 -->
    <el-dialog
      title="修改收货地址"
      :visible.sync="dialogVisible"
      width="30%"
      center
      custom-class="custom-addr-dialog"
      @close="$emit('update:visible', false)"
    >
      <el-form :model="sendModel" ref="sendForm" label-width="100px" size="small">
        <el-form-item label="姓名:" prop="senderName">
          <el-input v-model="sendModel.senderName"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="senderPhone">
          <el-input v-model="sendModel.senderPhone"></el-input>
        </el-form-item>
        <el-form-item label="收货地址:" prop="senderProvince">
          <el-cascader
            v-model="selectedOptions"
            :options="options"
            placeholder="省/市/区"
            @change="addressChoose"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址:" prop="senderDetailAddr">
          <el-input v-model="sendModel.senderDetailAddr" type="textarea" rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogConfirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 省市区
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
// 修改订单
import { updateOrderSmall } from "@/api/mall.js";
export default {
  name: "SmallAddress",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 订单对象
    myOrder: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      sendModel: {},
      // 保存地区级联选择器已选择的数据
      selectedOptions: [],
      options: regionData
    };
  },
  watch: {
    visible(newValue) {
      this.dialogVisible = newValue;
      this.sendModel = JSON.parse(JSON.stringify(this.myOrder));
      console.log("this", this.myOrder);
      let arr = [];
      arr.push(TextToCode[this.sendModel.senderProvince].code);
      arr.push(
        TextToCode[this.sendModel.senderProvince][this.sendModel.senderCity]
          .code
      );
      arr.push(
        TextToCode[this.sendModel.senderProvince][this.sendModel.senderCity][
          this.sendModel.senderRegion
        ].code
      );
      this.selectedOptions = arr;
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 确定按钮
    handleDialogConfirm() {
      let data = JSON.parse(JSON.stringify(this.sendModel));
      //订单修改寄回地址
      updateOrderSmall(data)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success("修改收货地址成功！");
            // 完成后，触发一个事件通知父组件刷新数据
            this.$emit("refreshList", data);
          }
        })
        .catch(err => {});
    },
    // 地区三级级选择器
    addressChoose(value) {
      //我们选择地址后，selectedOptions 会保存对应的区域码，例如北京的区域码为'110000'
      //我们要取出区域码对应的汉字，就需要用CodeToText(区域码)进行输出
      this.sendModel.senderProvince = CodeToText[value[0]];
      this.sendModel.senderCity = CodeToText[value[1]];
      this.sendModel.senderRegion = CodeToText[value[2]];
    }
  }
};
</script>

<style scoped lang="less">
.addr-update {
  /deep/ .custom-addr-dialog {
    height: 370px !important;
    margin-top: 100px !important;
    .el-dialog__body {
      padding: 10px 25px 0;
      .el-input__inner {
        width: 260px;
      }
      .el-textarea__inner {
        width: 260px;
      }
    }
  }
}
</style>
